import { Api } from 'api';
import { LoyaltyStore } from './LoyaltyStore';
import { ModalStore } from './Modal';
import { CartStore } from './Cart';
import { UserStore } from './UserStore';

class RootStore {
  constructor(url) {
    this.api = new Api(url);
    this.modalStore = new ModalStore(this);
    this.cartStore = new CartStore(this);
    this.loyaltyStore = new LoyaltyStore(this);
    this.userStore = new UserStore(this);
  }
}

export default new RootStore(process.env.REACT_APP_API_FETCH_URL);
